import { HTMLAttributes } from 'react'
import { css, styled } from 'styled-components'

export const SvgIcon = styled.svg`
	/* width: ${({ theme }) => theme.spacings.lg};
	height: ${({ theme }) => theme.spacings.lg}; */
	fill: ${({ theme }) =>
		theme.darkMode
			? theme.colors.extended.grey[100]
			: theme.colors.bases.primary[800]};
`

export const ChevronIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		viewBox="0 0 24 24"
		width="24"
		height="24"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.24744 4.34151C7.61112 3.92587 8.24288 3.88375 8.65852 4.24744L16.6585 11.2474C16.8755 11.4373 17 11.7116 17 12C17 12.2884 16.8755 12.5627 16.6585 12.7526L8.65852 19.7526C8.24288 20.1163 7.61112 20.0742 7.24744 19.6585C6.88375 19.2429 6.92587 18.6111 7.34151 18.2474L14.4814 12L7.34151 5.75259C6.92587 5.38891 6.88375 4.75715 7.24744 4.34151Z"
		/>
	</SvgIcon>
)

export const RotatingChevronIcon = styled(ChevronIcon)<{ $isOpen: boolean }>`
	vertical-align: middle;
	transform: rotate(-90deg);
	transition: transform 0.3s;
	${({ $isOpen }) =>
		!$isOpen &&
		css`
			transform: rotate(90deg);
		`}
`

export const InfoIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		viewBox="0 0 20 20"
		width="20"
		height="20"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM20 10C20 15.5229 15.5228 20 10 20C4.47715 20 -4.82823e-07 15.5228 0 10C4.82823e-07 4.47715 4.47715 -4.82823e-07 10 0C15.5229 4.82823e-07 20 4.47715 20 10Z"
		/>
		<path d="M9 6.00003C9 5.44774 9.44772 5.00003 10 5.00003C10.5523 5.00003 11 5.44774 11 6.00003C11 6.55231 10.5523 7.00003 10 7.00003C9.44772 7.00003 9 6.55231 9 6.00003Z" />
		<path d="M11 14.6C11 15.1523 10.5523 15.6 10 15.6C9.44772 15.6 9 15.1523 9 14.6L9 9.4C9 8.84772 9.44772 8.4 10 8.4C10.5523 8.4 11 8.84772 11 9.4L11 14.6Z" />
	</SvgIcon>
)

export const SuccessIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		viewBox="0 0 20 20"
		width="20"
		height="20"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.261 6.14683C15.6494 6.53952 15.6459 7.17268 15.2532 7.56103L9.13554 13.611C8.74443 13.9978 8.11438 13.9961 7.72538 13.6072L4.643 10.5258C4.25242 10.1354 4.25232 9.50219 4.64278 9.11161C5.03324 8.72102 5.66641 8.72092 6.05699 9.11138L8.43618 11.4898L13.8468 6.13897C14.2395 5.75063 14.8727 5.75415 15.261 6.14683Z"
		/>
	</SvgIcon>
)

export const CarretDownIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		width="14"
		height="8"
		viewBox="0 0 14 8"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path d="M7.70701 7.29289L13.2928 1.70711C13.9228 1.07714 13.4766 0 12.5857 0H1.41412C0.523211 0 0.0770421 1.07714 0.707007 1.70711L6.2928 7.29289C6.68332 7.68342 7.31648 7.68342 7.70701 7.29289Z" />
	</SvgIcon>
)

export const CarretUpIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		width="14"
		height="8"
		viewBox="0 0 14 8"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			d="M7.70701 7.29289L13.2928 1.70711C13.9228 1.07714 13.4766 0 12.5857 0H1.41412C0.523211 0 0.0770421 1.07714 0.707007 1.70711L6.2928 7.29289C6.68332 7.68342 7.31648 7.68342 7.70701 7.29289Z"
			transform="scale(1,-1) translate(0,-8)"
		/>
	</SvgIcon>
)

export function SearchIcon({ ...props }) {
	return (
		<SvgIcon
			{...props}
			width="24"
			height="24"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.25 6a4.25 4.25 0 100 8.5 4.25 4.25 0 000-8.5zM4 10.25a6.25 6.25 0 1112.5 0 6.25 6.25 0 01-12.5 0z"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18.293 19.707l-5.056-5.056 1.414-1.414 5.056 5.056a1 1 0 01-1.414 1.414z"
			/>
		</SvgIcon>
	)
}

export const ErrorIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		width="20"
		height="19"
		viewBox="0 0 20 19"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10 0C10.3704 0 10.7105 0.204749 10.8838 0.532112L19.8838 17.5321C20.0479 17.8421 20.0376 18.2153 19.8567 18.5158C19.6758 18.8163 19.3507 19 19 19H1C0.649283 19 0.324198 18.8163 0.143295 18.5158C-0.0376073 18.2153 -0.0478841 17.8421 0.116212 17.5321L9.11621 0.532112C9.28952 0.204749 9.62959 0 10 0ZM2.66091 17H17.3391L10 3.13727L2.66091 17Z"
		/>
		<path d="M11 14.5C11 15.0579 10.5579 15.5 10 15.5C9.44214 15.5 9 15.0579 9 14.5C9 13.9421 9.44214 13.5 10 13.5C10.5579 13.5 11 13.9421 11 14.5Z" />
		<path d="M8.99999 7.5C8.99999 6.94214 9.44212 6.5 9.99998 6.5C10.5578 6.5 11 6.94214 11 7.5V11C11 11.5579 10.5576 12 9.99969 12C9.44183 12 8.99999 11.5579 8.99999 11V7.5Z" />
	</SvgIcon>
)

export const ReturnIcon = (props: HTMLAttributes<SVGElement>) => (
	<SvgIcon
		{...props}
		width="16"
		height="13"
		viewBox="0 0 16 13"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1 0C1.55228 0 2 0.447715 2 1V6.65C2 7.20228 2.44772 7.65 3 7.65H15C15.5523 7.65 16 8.09771 16 8.65C16 9.20228 15.5523 9.65 15 9.65H3C1.34314 9.65 0 8.30685 0 6.65V1C0 0.447715 0.447715 0 1 0Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.5407 4.69739C11.9564 4.33371 12.5881 4.37582 12.9518 4.79146L15.7518 7.99146C16.0817 8.36849 16.0817 8.93144 15.7518 9.30847L12.9518 12.5085C12.5881 12.9241 11.9564 12.9662 11.5407 12.6025C11.1251 12.2389 11.083 11.6071 11.4467 11.1915L13.6705 8.64997L11.4467 6.10847C11.083 5.69283 11.1251 5.06107 11.5407 4.69739Z"
		/>
	</SvgIcon>
)

export const EditIcon = (props: HTMLAttributes<SVGElement>) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="#1D458C"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M17.6713 4.34045C17.1223 3.79142 16.1035 3.9201 15.3957 4.62786L14.0118 6.01178L17.9882 9.98822L19.3721 8.6043C20.0799 7.89653 20.2086 6.8777 19.6595 6.32867L17.6713 4.34045ZM16.4882 11.4882L12.5118 7.51178L5.26693 14.7566C4.94924 15.0743 4.73441 15.4722 4.66412 15.8732L4.00634 19.625C3.96438 19.8643 4.13568 20.0356 4.37496 19.9937L8.12685 19.3359C8.52777 19.2656 8.92567 19.0508 9.24336 18.7331L16.4882 11.4882Z"
		/>
	</svg>
)

export const TriangleIcon = (props: HTMLAttributes<SVGElement>) => (
	<svg
		{...props}
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="#1D458C"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path d="M8 3L13.1962 12H2.80385L8 3Z" />
	</svg>
)

export const SquareIcon = (props: HTMLAttributes<SVGElement>) => (
	<svg
		{...props}
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="#1D458C"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
		className={'square-icon' + (props.className ? ' ' + props.className : '')}
	>
		<path d="M3 3H13V13H3V3Z" />
	</svg>
)

export const RhombusIcon = styled(SquareIcon)`
	transform: rotate(45deg);
`

export const HexagonIcon = (props: HTMLAttributes<SVGElement>) => (
	<svg
		{...props}
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="#1D458C"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path d="M8 3L12.3301 5.5V10.5L8 13L3.66987 10.5V5.5L8 3Z" />
	</svg>
)

export const CircleIcon = (props: HTMLAttributes<SVGElement>) => (
	<svg
		{...props}
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="#1D458C"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path d="M8 3L8.52264 3.02739L9.03956 3.10926L9.54508 3.24472L10.0337 3.43227L10.5 3.66987L10.9389 3.95492L11.3457 4.28428L11.7157 4.65435L12.0451 5.06107L12.3301 5.5L12.5677 5.96632L12.7553 6.45492L12.8907 6.96044L12.9726 7.47736L13 8L12.9726 8.52264L12.8907 9.03956L12.7553 9.54508L12.5677 10.0337L12.3301 10.5L12.0451 10.9389L11.7157 11.3457L11.3457 11.7157L10.9389 12.0451L10.5 12.3301L10.0337 12.5677L9.54508 12.7553L9.03956 12.8907L8.52264 12.9726L8 13L7.47736 12.9726L6.96044 12.8907L6.45492 12.7553L5.96632 12.5677L5.5 12.3301L5.06107 12.0451L4.65435 11.7157L4.28428 11.3457L3.95492 10.9389L3.66987 10.5L3.43227 10.0337L3.24472 9.54508L3.10926 9.03956L3.02739 8.52264L3 8L3.02739 7.47736L3.10926 6.96044L3.24472 6.45492L3.43227 5.96632L3.66987 5.5L3.95492 5.06107L4.28428 4.65435L4.65435 4.28428L5.06107 3.95492L5.5 3.66987L5.96632 3.43227L6.45492 3.24472L6.96044 3.10926L7.47736 3.02739L8 3Z" />
	</svg>
)

export const HelpIcon = (props: HTMLAttributes<SVGElement>) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="#1D458C"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12.9725 16.5886C12.9725 17.1472 12.5197 17.6 11.9612 17.6C11.4026 17.6 10.9498 17.1472 10.9498 16.5886C10.9498 16.0301 11.4026 15.5772 11.9612 15.5772C12.5197 15.5772 12.9725 16.0301 12.9725 16.5886ZM10.6146 9.25871C10.6784 9.05633 10.7844 8.86166 10.9534 8.71892C11.1062 8.58978 11.3903 8.43428 11.949 8.43296L11.9495 8.43297C11.9552 8.43316 11.9681 8.43369 11.9873 8.43506C12.0261 8.43782 12.088 8.44382 12.165 8.4566C12.3237 8.48295 12.5199 8.53377 12.7037 8.62531C12.8836 8.71493 13.0322 8.83327 13.138 8.9913C13.2394 9.14281 13.3416 9.38993 13.3416 9.80899C13.3416 10.1472 13.1563 10.4615 12.8509 10.747C12.7055 10.8829 12.5563 10.989 12.4428 11.0609C12.387 11.0962 12.3424 11.1216 12.3147 11.1368L12.3005 11.1444C11.704 11.4042 11.3207 11.8034 11.1131 12.2523C10.9193 12.6712 10.9196 13.0527 10.9198 13.1824L10.9198 13.1912V13.5544C10.9198 14.113 11.3726 14.5658 11.9312 14.5658C12.4897 14.5658 12.9426 14.113 12.9426 13.5544V13.1912C12.9426 13.115 12.9473 13.1049 12.9489 13.1017L12.949 13.1014L12.9492 13.101L12.9502 13.0995C12.9512 13.0981 12.9547 13.0933 12.9627 13.0858C12.9775 13.0718 13.0214 13.0352 13.1209 12.9935C13.1372 12.9867 13.1534 12.9794 13.1693 12.9717L12.7301 12.0607C13.1693 12.9717 13.1696 12.9716 13.17 12.9714L13.1707 12.9711L13.1722 12.9703L13.1758 12.9686L13.1847 12.9642L13.2095 12.9517C13.229 12.9417 13.2545 12.9283 13.285 12.9116C13.3461 12.8782 13.4283 12.831 13.5246 12.7701C13.7154 12.6493 13.9719 12.468 14.2322 12.2247C14.7383 11.7516 15.3644 10.9401 15.3644 9.80899C15.3644 9.03433 15.167 8.38616 14.819 7.8662C14.4754 7.35277 14.0247 7.02346 13.6054 6.81465C13.19 6.60776 12.7869 6.50937 12.4963 6.46111C12.3485 6.43659 12.2232 6.42394 12.1309 6.41737C12.0846 6.41407 12.046 6.41227 12.0166 6.41129C12.0019 6.4108 11.9894 6.41052 11.9793 6.41036L11.9659 6.41019L11.9605 6.41016L11.9582 6.41016L11.9571 6.41015C11.9566 6.41015 11.9561 6.41015 11.9561 7.42155V6.41015C10.9764 6.41015 10.2108 6.69811 9.64782 7.17384C9.10024 7.63652 8.82473 8.20846 8.68535 8.65082C8.51749 9.18358 8.8133 9.75155 9.34606 9.91941C9.87882 10.0873 10.4468 9.79147 10.6146 9.25871ZM12.2868 11.1516L12.2872 11.1513C12.2851 11.1524 12.2843 11.1528 12.2849 11.1525L12.2868 11.1516Z"
		/>
	</svg>
)

export const CheckmarkIcon = (props: HTMLAttributes<SVGElement>) => (
	<svg
		{...props}
		width="24"
		height="12"
		viewBox="0 0 16 12"
		fill="#3CB053"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.7109 0.697112C16.0993 1.08974 16.0959 1.7229 15.7033 2.11131L6.39385 11.3207C6.00272 11.7077 5.37249 11.706 4.98346 11.3169L0.292893 6.62637C-0.0976311 6.23584 -0.0976311 5.60268 0.292893 5.21215C0.683417 4.82163 1.31658 4.82163 1.70711 5.21215L5.69437 9.19942L14.2967 0.689476C14.6894 0.301066 15.3225 0.304485 15.7109 0.697112Z"
		/>
	</svg>
)

export const CrossIcon = (props: HTMLAttributes<SVGElement>) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="#6C757D"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.69372 17.2999C6.30319 16.9094 6.30319 16.2762 6.69372 15.8857L15.8861 6.69328C16.2766 6.30276 16.9098 6.30276 17.3003 6.69328C17.6908 7.08381 17.6908 7.71697 17.3003 8.1075L8.10793 17.2999C7.71741 17.6904 7.08424 17.6904 6.69372 17.2999Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.66399 6.69331C7.05451 6.30278 7.68768 6.30278 8.0782 6.69331L17.2706 15.8857C17.6611 16.2762 17.6611 16.9094 17.2706 17.2999C16.8801 17.6904 16.2469 17.6904 15.8564 17.2999L6.66399 8.10752C6.27346 7.71699 6.27346 7.08383 6.66399 6.69331Z"
		/>
	</svg>
)

export const ExternalLinkIcon = (props: HTMLAttributes<SVGElement>) => (
	<svg
		{...props}
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="#6C757D"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.69372 17.2999C6.30319 16.9094 6.30319 16.2762 6.69372 15.8857L15.8861 6.69328C16.2766 6.30276 16.9098 6.30276 17.3003 6.69328C17.6908 7.08381 17.6908 7.71697 17.3003 8.1075L8.10793 17.2999C7.71741 17.6904 7.08424 17.6904 6.69372 17.2999Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M0.292969 2.83301C0.292969 1.45229 1.41226 0.333008 2.79297 0.333008H4.6388C5.09904 0.333008 5.47214 0.706104 5.47214 1.16634C5.47214 1.62658 5.09904 1.99967 4.6388 1.99967H2.79297C2.33273 1.99967 1.95964 2.37277 1.95964 2.83301V11.208C1.95964 11.6682 2.33273 12.0413 2.79297 12.0413L11.168 12.0413C11.6282 12.0413 12.0013 11.6682 12.0013 11.208V9.36217C12.0013 8.90194 12.3744 8.52884 12.8346 8.52884C13.2949 8.52884 13.668 8.90194 13.668 9.36217V11.208C13.668 12.5887 12.5487 13.708 11.168 13.708L2.79297 13.708C1.41226 13.708 0.292969 12.5887 0.292969 11.208V2.83301ZM7.83464 1.99967C7.3744 1.99967 7.0013 1.62658 7.0013 1.16634C7.0013 0.706104 7.3744 0.333008 7.83464 0.333008H12.8346C13.2949 0.333008 13.668 0.706104 13.668 1.16634V6.16634C13.668 6.62658 13.2949 6.99967 12.8346 6.99967C12.3744 6.99967 12.0013 6.62658 12.0013 6.16634V3.17819L8.42389 6.7556C8.09845 7.08103 7.57082 7.08103 7.24538 6.7556C6.91994 6.43016 6.91994 5.90252 7.24538 5.57709L10.8228 1.99967H7.83464Z"
			fill="#212529"
		/>
	</svg>
)

export const CircledArrowIcon = (props: HTMLAttributes<SVGElement>) => (
	<svg
		{...props}
		width="40"
		height="40"
		viewBox="0 0 45 45"
		fill="#1D458C"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M23.1195 13.6676C23.5243 13.2918 24.157 13.3152 24.5328 13.7199L29.7328 19.3199C30.0891 19.7036 30.0891 20.2972 29.7328 20.6808L24.5328 26.2808C24.157 26.6856 23.5243 26.709 23.1195 26.3332C22.7148 25.9574 22.6914 25.3247 23.0672 24.9199L27.6354 20.0004L23.0672 15.0808C22.6914 14.6761 22.7148 14.0434 23.1195 13.6676Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10 20.0004C10 19.4481 10.4477 19.0004 11 19.0004L29 19.0004C29.5523 19.0004 30 19.4481 30 20.0004C30 20.5527 29.5523 21.0004 29 21.0004L11 21.0004C10.4477 21.0004 10 20.5527 10 20.0004Z"
			fill="white"
		/>
	</svg>
)

export const PlusCircleIcon = (props: HTMLAttributes<SVGElement>) => (
	<svg
		{...props}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="#2E5FB6"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM22 12C22 17.5229 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5229 2 22 6.47715 22 12Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M17.2 12C17.2 12.5523 16.7523 13 16.2 13L7.8 13C7.24771 13 6.8 12.5523 6.8 12C6.8 11.4477 7.24771 11 7.8 11L16.2 11C16.7523 11 17.2 11.4477 17.2 12Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M12 17.2C11.4477 17.2 11 16.7523 11 16.2L11 7.8C11 7.24772 11.4477 6.8 12 6.8C12.5523 6.8 13 7.24771 13 7.8L13 16.2C13 16.7523 12.5523 17.2 12 17.2Z"
		/>
	</svg>
)

export const ArrowRightIcon = (props: HTMLAttributes<SVGElement>) => (
	<svg
		{...props}
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="#212529"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.91877 0.667113C7.32348 0.29131 7.95621 0.314745 8.33201 0.719455L13.532 6.31945C13.8883 6.70314 13.8883 7.29668 13.532 7.68036L8.33201 13.2804C7.95621 13.6851 7.32348 13.7085 6.91877 13.3327C6.51406 12.9569 6.49062 12.3242 6.86643 11.9195L11.4346 6.99991L6.86643 2.08036C6.49062 1.67565 6.51406 1.04292 6.91877 0.667113Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M0.199219 6.99991C0.199219 6.44762 0.646934 5.99991 1.19922 5.99991L12.7992 5.99991C13.3515 5.99991 13.7992 6.44762 13.7992 6.9999C13.7992 7.55219 13.3515 7.9999 12.7992 7.9999L1.19922 7.99991C0.646934 7.99991 0.199219 7.55219 0.199219 6.99991Z"
		/>
	</svg>
)

export const WarningIcon = (props: HTMLAttributes<SVGElement>) => (
	<svg
		{...props}
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="#FFBB0C"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.72825 0.928245C9.58121 0.663907 9.30248 0.5 9 0.5C8.69752 0.5 8.41879 0.663907 8.27175 0.928245L0.855084 14.2616C0.711514 14.5197 0.715285 14.8345 0.864996 15.0891C1.01471 15.3437 1.28799 15.5 1.58333 15.5H16.4167C16.712 15.5 16.9853 15.3437 17.135 15.0891C17.2847 14.8345 17.2885 14.5197 17.1449 14.2616L9.72825 0.928245ZM8.99992 4.91667C8.53968 4.91667 8.16658 5.28976 8.16658 5.75V9.91667C8.16658 10.3769 8.53968 10.75 8.99992 10.75C9.46016 10.75 9.83325 10.3769 9.83325 9.91667V5.75C9.83325 5.28976 9.46016 4.91667 8.99992 4.91667ZM8.99992 13.4583C9.46016 13.4583 9.83325 13.0852 9.83325 12.625C9.83325 12.1648 9.46016 11.7917 8.99992 11.7917C8.53968 11.7917 8.16658 12.1648 8.16658 12.625C8.16658 13.0852 8.53968 13.4583 8.99992 13.4583Z"
		/>
	</svg>
)

export const GithubIcon = (props: HTMLAttributes<SVGElement>) => (
	<svg
		{...props}
		width="18"
		height="18"
		viewBox="15 15 34 34"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32,16c-8.8,0-16,7.2-16,16c0,7.1,4.6,13.1,10.9,15.2 c0.8,0.1,1.1-0.3,1.1-0.8c0-0.4,0-1.4,0-2.7c-4.5,1-5.4-2.1-5.4-2.1c-0.7-1.8-1.8-2.3-1.8-2.3c-1.5-1,0.1-1,0.1-1 c1.6,0.1,2.5,1.6,2.5,1.6c1.4,2.4,3.7,1.7,4.7,1.3c0.1-1,0.6-1.7,1-2.1c-3.6-0.4-7.3-1.8-7.3-7.9c0-1.7,0.6-3.2,1.6-4.3 c-0.2-0.4-0.7-2,0.2-4.2c0,0,1.3-0.4,4.4,1.6c1.3-0.4,2.6-0.5,4-0.5c1.4,0,2.7,0.2,4,0.5c3.1-2.1,4.4-1.6,4.4-1.6 c0.9,2.2,0.3,3.8,0.2,4.2c1,1.1,1.6,2.5,1.6,4.3c0,6.1-3.7,7.5-7.3,7.9c0.6,0.5,1.1,1.5,1.1,3c0,2.1,0,3.9,0,4.4 c0,0.4,0.3,0.9,1.1,0.8C43.4,45.1,48,39.1,48,32C48,23.2,40.8,16,32,16z"
		/>
	</svg>
)

export const ClockIcon = (props: HTMLAttributes<SVGElement>) => (
	<svg
		{...props}
		width="20"
		height="20"
		viewBox="0 0 20 20"
		// fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
			// fill="#212529"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10 3.85C10.5523 3.85 11 4.29771 11 4.85V9.95C11 10.5023 10.5523 10.95 10 10.95C9.44771 10.95 9 10.5023 9 9.95V4.85C9 4.29771 9.44771 3.85 10 3.85Z"
			// fill="#212529"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M5.43058 12.1087C5.19894 11.6073 5.4176 11.0131 5.91896 10.7815L9.55013 9.10383C10.0515 8.87219 10.6457 9.09084 10.8773 9.5922C11.109 10.0936 10.8903 10.6878 10.389 10.9194L6.75779 12.5971C6.25643 12.8287 5.66222 12.6101 5.43058 12.1087Z"
			// fill="#212529"
		/>
	</svg>
)

export const EyeIcon = (props: HTMLAttributes<SVGElement>) => (
	<svg
		{...props}
		width="16"
		height="16"
		viewBox="0 0 576 512"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden
	>
		{/* Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc. */}
		<path d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z" />
	</svg>
)

export { Loader } from './Loader'
